module.exports = __webpack_public_path__ + "media/images/email_icon-e1385b28.png";